import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";

const Alerts = {
  operationSuccess: (
    title = "¡Excelente!",
    message = "¡Se ha realizado la operación con éxito!",
    icon = "success",
  ) => {
    return Swal.fire({
      title,
      text: message,
      icon,
      confirmButtonColor: "#2E6DA4",
    });
  },

  alertloading: (title) => {
    return Swal.fire({
      title: title,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });
  },

  closeAlert: (bool = false) => {
    if (bool) {
      Swal.close();
    }
  },

  serverError: (
    title = "Error!",
    message = "¡Error en servidor interno, porfavor intente nuevamente!",
  ) => {
    Swal.fire({
      icon: "warning",
      title: title,
      text: message,
      confirmButtonColor: "#2E6DA4",
    });
  },

  operationNotAllowed: (
    title = "¡Atención!",
    message = "¡Operación no permitida!",
  ) => {
    Swal.fire({
      icon: "warning",
      title: title,
      text: message,
      confirmButtonColor: "#2E6DA4",
    });
  },

  alertBase: ({ title = "¿Seguro?", icon }) => {
    return Swal.fire({
      title,
      icon,
      confirmButtonColor: "#2E6DA4",
    });
  },

  operationFail: ({ title = "¿Seguro?", icon }) => {
    return Swal.fire({
      title,
      icon,
      confirmButtonColor: "#2E6DA4",
    });
  },

  confirmationAlert: ({
    title = "¿Seguro?",
    text = "",
    html = "",
    icon = "warning",
    confirmButtonText = "Confirmar",
    cancelButtonText = "Cancelar",
    allowOutClick = true,
  }) => {
    return Swal.fire({
      title,
      text,
      html,
      icon,
      showCancelButton: true,
      confirmButtonColor: "#2E6DA4",
      confirmButtonText,
      cancelButtonText,
      allowOutsideClick: allowOutClick,
      allowEscapeKey: false,
      backdrop: true,
    });
  },

  alert: (message, icon) => {
    Alerts.alertBase({
      title: message,
      icon: icon,
    });
  },

  operationSuccessToast: (text = "Operación realizada con éxito") => {
    toast.success(text, toastDefaultOptions);
  },

  warnNotification: (text) => {
    toast.warn(text, toastDefaultOptions);
  },

  successNotification: (text = "Operación realizada con éxito") => {
    toast.success(text, { ...toastDefaultOptions, className: "bg-primary" });
  },
};

const toastDefaultOptions = {
  position: "top-right",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

const AlertsComponent = () => {
  return (
    <>
      <ToastContainer {...toastDefaultOptions} />
    </>
  );
};

export { Alerts, AlertsComponent as default };
